module.exports = __webpack_public_path__ + "static/media/cat.e8126c32.jpg";